import _ from 'lodash';

import AggregationAction from './AggregationAction';
import {SUMMATION_NAMES_ENUM} from './Dimensions';
import {METRIC_AGGREGATION_TYPES} from './MetricAggregations';

export default class MetricAggregationAction extends AggregationAction {

    aggregate(metricResponseAsJson, previousAggregatedResult) {
        const aggregateResponse = {
            aggregateDimensionList: this.normalizeGroupByDimensions(metricResponseAsJson.metricAggregationRequest.groupByDimensions),
            aggregateList: (metricResponseAsJson.metricAggregateList || []).map(metricAggregate => ({
                aggregateDimensionValueList: metricAggregate.aggregateDimensionValueList,
                quantity: this.getCardinalityValue(metricAggregate)
            })),
            shipmentTypes: metricResponseAsJson.shipmentTypes
        };

        const aggregatedResult = super.aggregate(aggregateResponse, previousAggregatedResult);
        return this.populateRangeTotalsForUnboundedReport(aggregatedResult);
    }

    normalizeGroupByDimensions(groupByDimensions) {
        return groupByDimensions.map(dimension => ({
            ...dimension,
            __type: MetricAggregationAction.getSimpleCoralTypeName(dimension.__type)
        }));
    }

    getCardinalityValue(metricAggregate) {
        const cardinalityResult = _.find(metricAggregate.metricResults || [], metricResult =>
            metricResult.metricAggregation?.type === METRIC_AGGREGATION_TYPES.CARDINALITY);
        return _.isNil(cardinalityResult) ? 0 : cardinalityResult.value;
    }

    populateRangeTotalsForUnboundedReport(aggregatedResult) {
        const populateRangeTotals = aggregateObject => {
            if (_.isNil(aggregateObject) || aggregateObject.hasTimeRange) {
                return;
            }
            aggregateObject.aggregateResultMap.forEach(rowDataMap => {
                const total = rowDataMap.get(SUMMATION_NAMES_ENUM.TOTAL);
                if (!_.isNil(total)) {
                    rowDataMap.set(SUMMATION_NAMES_ENUM.RANGE_TOTAL, total);
                }
            });
        };

        if (_.isMap(aggregatedResult)) {
            aggregatedResult.forEach(populateRangeTotals);
        } else {
            populateRangeTotals(aggregatedResult);
        }
        return aggregatedResult;
    }

    static getSimpleCoralTypeName(coralTypeName) {
        if (_.includes(coralTypeName, '#')) {
            return _.last(_.split(coralTypeName, '#'));
        }
        return _.head(_.split(coralTypeName, ':'));
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getBucketTimeStamp(timeStamp, bucketSize, aggregationActionTimeStamp) {
        // ES already applies the offset via bucketReferencePoint, so the
        // timestamp from the response IS the correct bucket start time.
        // No need to re-align with modulo (which would strip the offset).
        return timeStamp;
    }
}
